/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { string, func } from 'prop-types';
import Input from '../contact-info/input';

const Availability = (props) => {
  const {
    zipCode,
    zipCodeError,
    checkAvailability,
    handleChange,
    sfiPhoneNumber,
  } = props;
  return (
    <div className="flex-ns absolute-ns h-100 w-100">
      <div className="w-50-ns w-100 pa4-ns pa3">
        <h2 className="mb3 tc tl-ns lh-title f2-ns f3 near-black mt0 mt3-ns">Let&#39;s Get Started!</h2>
        <p className="f5">
          Enter your zip code to find out if our shutter
          experts are available for in-home consultation in your area.
        </p>
        <form onSubmit={checkAvailability}>
          <div className="w-100 mb2">
            <Input id="zipCode" value={zipCode} label="Zip Code" name="zipCode" maxLength={5} errorMessage={zipCodeError} handleChange={handleChange} />
          </div>
          <input className="gcc-btn gcc-btn-secondary w-100" type="submit" value="Check Availability" disabled={zipCodeError} />
        </form>
        <p className="tc mt3 mb0 f5" style={{ textAlign: 'center' }}>or call <a href={`tel:${sfiPhoneNumber}`} className="fw7 black">{sfiPhoneNumber}</a> to get started.</p>
      </div>
    </div>
  );
};

Availability.defaultProps = {
  zipCode: '',
  zipCodeError: '',
};

Availability.propTypes = {
  zipCode: string,
  zipCodeError: string,
  checkAvailability: func.isRequired,
  handleChange: func.isRequired,
  sfiPhoneNumber: string.isRequired,
};

export default Availability;
